import { defaultHeroCopy } from "@loot-os/api-contract";
import type { HeroContent } from "@loot-os/design-system/templates/home/homeContent";
import { useShopper } from "../../../../lib/shopper.js";
import { useTerminology } from "../../../../lib/terminology.js";

/**
 * The hero, when the store has no banner live: sign up or browse the boxes while signed out (the
 * header has the log-in), browse the boxes once signed in. The words are the store's default copy
 * (`defaultHeroCopy`).
 */
export function useHeroContent(): HeroContent {
  const { user } = useShopper();
  const copy = defaultHeroCopy(useTerminology());
  return {
    headline: copy.headline,
    body: copy.body,
    actions: user
      ? [{ label: copy.browse, emphasis: "primary", href: "/boxes" }]
      : [
          { label: copy.signUp, emphasis: "primary", href: "/login" },
          { label: copy.browse, emphasis: "secondary", href: "/boxes" },
        ],
    artUrl: "",
  };
}
